import { createAction, props } from '@ngrx/store';

export const loyaltyTileInit = createAction('[HOMEPAGE] Loyalty tile init', props<{ isRequested: boolean }>());

export const loyaltyTileRequest = createAction('[HOMEPAGE] Loyalty tile request access');

export const loyaltyTileRequestSuccess = createAction(
  '[HOMEPAGE] Loyalty tile request access success',
  props<{ isRequested: boolean }>()
);

export const loyaltyTileRequestError = createAction(
  '[HOMEPAGE] Loyalty tile request access error',
  props<{ error: string }>()
);
export const loyaltyTileApprove = createAction('[HOMEPAGE] Loyalty tile approve');

export const loyaltyTileApproveSuccess = createAction('[HOMEPAGE] Loyalty tile approve success');

export const loyaltyTileApproveError = createAction(
  '[HOMEPAGE] Loyalty tile approve error',
  props<{ error: string }>()
);
